import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { ImagePlaceholder } from './ImagePlaceholder';
const ingredientes = [{
  name: 'Inositol',
  icon: '🌿',
  func: 'Apoya el equilibrio hormonal y mejora la sensibilidad a la insulina',
  copy: 'Menos picos de azúcar, menos antojos, más equilibrio.',
  img: 'Polvo blanco + frutas',
  imgSrc: 'https://cdn.magicpatterns.com/uploads/jVp792V8C4FCpUiPfedMJW/8ebe34d5-c275-46df-94c2-f9e892e4f707.png'
}, {
  name: 'Vitamina B12',
  icon: '💊',
  func: 'Contribuye al metabolismo energético normal',
  copy: 'Energía real, sin ansiedad, sin picos.',
  img: 'Cápsulas / alimentos',
  imgSrc: 'https://cdn.magicpatterns.com/uploads/mmpvsb1rRfvtWVNmBrJFgG/864f893d-f2cb-4153-bec9-efb4146e40c6.png'
}, {
  name: 'Zinc',
  icon: '⚡',
  func: 'Contribuye al metabolismo normal de carbohidratos',
  copy: 'Menos conversión de azúcar en grasa. Más control metabólico.',
  img: 'Semillas / nueces',
  imgSrc: 'https://cdn.magicpatterns.com/uploads/qzqHAKvhM9g4rY28eGbDg4/b77aa986-8962-4d69-939c-37d4e2b49c4e.png'
}, {
  name: 'Magnesio',
  icon: '🌙',
  func: 'Contribuye a la función muscular y regula el cortisol nocturno',
  copy: 'Dormís mejor, el cortisol baja, el cuerpo suelta la grasa.',
  img: 'Mineral / noche',
  imgSrc: 'https://cdn.magicpatterns.com/uploads/2WeZSgS8nxxLBGD4JjJWKZ/fe7d84f0-2d1f-491d-9ea0-88272f89428e.png'
}, {
  name: 'Vitamina D3',
  icon: '☀️',
  func: 'Contribuye al sistema inmune y equilibrio hormonal',
  copy: 'La vitamina que el 80% de las mujeres argentinas tiene baja.',
  img: 'Sol / huevos',
  imgSrc: 'https://cdn.magicpatterns.com/uploads/unHo4dceqaiKjFUZmVB3Eg/5c885e16-8894-473d-b5df-420abfe9d4c1.png'
}, {
  name: 'Berberina HCI',
  icon: '🫚',
  func: 'Apoya el metabolismo saludable y la insulina',
  copy: 'La berberina que la ciencia llama "la metformina natural".',
  img: 'Raíz amarilla',
  imgSrc: 'https://cdn.magicpatterns.com/uploads/nzrhodSnnsBhzDjybJbPAE/4751c356-4930-4c6c-9c78-a8a75b09fc70.png'
}, {
  name: 'Ashwagandha',
  icon: '🧘',
  func: 'Reduce el cortisol y ayuda al bienestar',
  copy: 'Menos estrés = menos panza. Así de directo.',
  img: 'Raíz / polvo marrón',
  imgSrc: 'https://cdn.magicpatterns.com/uploads/aCpDacgTrEBTFFVBVUHt93/4c25fce7-17ed-494e-8835-85930d6f1590.png'
}, {
  name: 'Cromo',
  icon: '⚫',
  func: 'Apoya el metabolismo de macronutrientes',
  copy: 'El mineral que le dice a la insulina cómo comportarse.',
  img: 'Brócoli / granos',
  imgSrc: 'https://cdn.magicpatterns.com/uploads/tDcacLXfrL7CVmKrw4g8H9/e5a798b0-2446-4b10-9220-f861a0891cd3.png'
}];
export function Ingredientes() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scrollBy = (dir: number) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: dir * 340,
        behavior: 'smooth'
      });
    }
  };
  return <section className="bg-white py-16 md:py-24 overflow-hidden" data-id="element-171">
      <div className="max-w-6xl mx-auto px-4 mb-10 flex items-end justify-between gap-4" data-id="element-172">
        <div data-id="element-173">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-174">
            Los 8 activos que hacen que ESBELTA® funcione distinto
          </h2>
          <p className="text-lg text-gray-600" data-id="element-175">
            No es una gomita de vitaminas. Es una fórmula diseñada para el
            metabolismo femenino maduro.
          </p>
        </div>
        <div className="hidden md:flex items-center gap-2 flex-shrink-0" data-id="element-176">
          <button onClick={() => scrollBy(-1)} aria-label="Anterior" className="w-10 h-10 rounded-full bg-esbelta-lavender text-esbelta-violet flex items-center justify-center hover:bg-esbelta-violet hover:text-white transition-colors" data-id="element-177">
            <ChevronLeftIcon className="w-5 h-5" data-id="element-178" />
          </button>
          <button onClick={() => scrollBy(1)} aria-label="Siguiente" className="w-10 h-10 rounded-full bg-esbelta-lavender text-esbelta-violet flex items-center justify-center hover:bg-esbelta-violet hover:text-white transition-colors" data-id="element-179">
            <ChevronRightIcon className="w-5 h-5" data-id="element-180" />
          </button>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4" data-id="element-181">
        <motion.div ref={scrollRef} className="flex gap-6 overflow-x-auto pb-8 snap-x snap-mandatory hide-scrollbar scroll-smooth" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }} data-id="element-182">
          {ingredientes.map((ing, idx) => <div key={idx} className="min-w-[280px] md:min-w-[320px] bg-esbelta-lavender/40 rounded-2xl p-6 snap-start border border-esbelta-violet/10 flex flex-col" data-id="element-183">
              <div className="w-full rounded-xl overflow-hidden mb-6 bg-white" data-id="element-184">
                {ing.imgSrc ? <img src={ing.imgSrc} alt={ing.name} className="w-full h-auto object-contain" data-id="element-185" /> : <div className="aspect-video w-full" data-id="element-186">
                    <ImagePlaceholder label={ing.img} className="w-full h-full" data-id="element-187" />
                  </div>}
              </div>
              <div className="flex items-center gap-2 mb-3" data-id="element-188">
                <span className="text-2xl" data-id="element-189">{ing.icon}</span>
                <h3 className="font-bold text-xl text-gray-900" data-id="element-190">{ing.name}</h3>
              </div>
              <p className="text-gray-600 text-sm mb-4 flex-grow" data-id="element-191">{ing.func}</p>
              <div className="pt-4 border-t border-gray-200 mt-auto" data-id="element-192">
                <p className="font-medium text-esbelta-violet text-sm italic" data-id="element-193">
                  "{ing.copy}"
                </p>
              </div>
            </div>)}
        </motion.div>
      </div>

      <style dangerouslySetInnerHTML={{
      __html: `
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `
    }} data-id="element-194" />
    </section>;
}